export default{

    titulo:{
        salones: 'Salones',
        salon: 'Salón',
        salonArticulo: 'El Salón',
        salonesArticulo: 'Los Salones',


        director: 'Director',
        directores: 'Directores',
        directorArticulo: 'El Director',
        directoresArticulo: 'Los Directores',

        colegio: 'Colegio',
        colegios: 'Colegios',
        colegioArticulo: 'El Colegio',
        colegiosArticulo: 'Los Colegios',

      
    },



    ubicacion:{
        pais: 'País',
        ubicacion1: 'Departamento',
        ubicacion2: 'Provincia',
        ubicacion3: 'Distrito'

    },

    modulos:{
        10: "Inicio",
        11: "Manager",
        20: "Reportes",
        1000:"Configuración sistema",
        1100:"Inventario",
        1200:"Cliente",
        1300:"Gastos",
        1400:"Compra",
        1500:"Venta",
        1600:"Administrativo",
        1900:"Agremiado",
        2000:"Website"
    },

    subModulos:{
        100: "Gestión de empresas",
        110: "Gestión de licencias",
        120: "Permisos de usuarios",
        130: "Usuarios",
        
        1000:"Configuración",
        1010:"Perfil usuario",
        1020:"Usuario sistema",
        1030:"Impuesto",
        1035:"Transporte",
        1040:"Tipo de documento",
        1045:"Moneda",
        1050:"Zona",

        1101:"Productos",
        1102:"Ajuste",
        1103:"Existencia",
        1104:"Almacén",
        1105:"Categoría",
        1106:"Línea",
        1107:"Sublínea",
        1108:"Unidad medida",
        1109:"Proveedor",
        1110:"Alerta de stock",

        1201:"Cliente",
        1202:"Tipo de vliente",
        1203:"Agremiado",
        1205:"Vendedor",
        1206:"Tipo de vendedor",


        1410:"Compra",
        1420:"Proveedor",
        1430:"Tipo de proveedor",
   

        1510:"Venta",
        1550:"Cuenta por vobrar",
        1560:"Cuenta por cobrar masivo",

        1610:"Importar",
        


        1920:"Constancia de afiliacion",
        1910:"Carnet electrónico",

        2110:"Documentos",
        2120:"Documentos categoría"

    },

    action:{
        delete: 'Borrar'
    }


}